import { render, staticRenderFns } from "./VModalVideo.vue?vue&type=template&id=8200edba&"
import script from "./VModalVideo.vue?vue&type=script&lang=ts&"
export * from "./VModalVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports